module.exports = __webpack_public_path__ + "img/3_40.8fb4838a.png";